import React from 'react';
import { PhilBotApp } from '@data/utils/types';
import { GithubIcon, GoogleCalendarIcon, SlackIcon } from './appIcons';

export interface PhilBotAppMeta {
  key: PhilBotApp;
  label: string;
  /** i18n key for the one line saying what Phill reads from this source. */
  descriptionKey: string;
  icon: React.ComponentType<{ className?: string }>;
}

// Slack is listed first because it is the one Phill messages you on, not because anything waits for it.
// All three are independent, and any of them can be connected on its own.
export const PHIL_BOT_APPS: PhilBotAppMeta[] = [
  // Not "messages you": Phill takes your Slack id from your email, so it can reach you whether or not
  // this is connected. Connecting only lets it read what you posted.
  { key: 'slack', label: 'Slack', descriptionKey: 'philBot.sources.slack', icon: SlackIcon },
  { key: 'github', label: 'GitHub', descriptionKey: 'philBot.sources.github', icon: GithubIcon },
  {
    key: 'googleCalendar',
    label: 'Google Calendar',
    descriptionKey: 'philBot.sources.googleCalendar',
    icon: GoogleCalendarIcon,
  },
];
